var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.01 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8200DC",
    d: "M505.75,475.58,360.15,330a201.67,201.67,0,0,0,45.18-127.31C405.33,90.92,314.41,0,202.67,0S0,90.92,0,202.67,90.92,405.33,202.67,405.33A201.67,201.67,0,0,0,330,360.15l145.6,145.6a21.33,21.33,0,0,0,30.17-30.17ZM202.67,362.67c-88.24,0-160-71.77-160-160s71.76-160,160-160,160,71.76,160,160S290.9,362.67,202.67,362.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3ebfa4656ab5786216bf00a4174a480b.svg";
export { ForwardRef as ReactComponent };